import type { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { $api } from '../axios/axios';
import { CandidateOfferItem } from 'shared/core/store';
import { DateFormats, OffersType } from '@constants';

const removeTraineeOfferHiddenFields = (data: CandidateOfferItem): Partial<CandidateOfferItem> => {
  if (data.offerType !== OffersType.TraineeOffer) return data;

  const traineeOfferData: Partial<CandidateOfferItem> = { ...data };
  delete traineeOfferData.currency;
  delete traineeOfferData.project;
  delete traineeOfferData.probationPeriod;
  delete traineeOfferData.salaryGross;
  delete traineeOfferData.salaryProbationGross;
  delete traineeOfferData.salaryProjectGross;
  delete traineeOfferData.taxResidencyId;

  return traineeOfferData;
};

export default class OffersService {
  static async getCandidateOffers(candidateId: number): Promise<AxiosResponse> {
    return $api.get(`/recruiting-tool/api/v1/offer/${candidateId}`);
  }

  static async createOffer(data: CandidateOfferItem): Promise<AxiosResponse> {
    const normalizedData = removeTraineeOfferHiddenFields(data);

    return $api.post(`/recruiting-tool/api/v1/offer`, {
      ...normalizedData,
      taxResidencyId: normalizedData.taxResidencyId ? Number(normalizedData.taxResidencyId) : undefined,
      responseDate: normalizedData.responseDate
        ? format(new Date(normalizedData.responseDate), DateFormats.ISO)
        : normalizedData.responseDate,
      offerDate: normalizedData.offerDate
        ? format(new Date(normalizedData.offerDate), DateFormats.ISO)
        : normalizedData.offerDate,
      estimatedReleaseDate: normalizedData.estimatedReleaseDate
        ? format(new Date(normalizedData.estimatedReleaseDate), DateFormats.ISO)
        : normalizedData.estimatedReleaseDate,
    });
  }

  static async updateOffer(data: CandidateOfferItem): Promise<AxiosResponse> {
    const normalizedData = removeTraineeOfferHiddenFields(data);

    return $api.put(`/recruiting-tool/api/v1/offer`, {
      ...normalizedData,
      responseDate: normalizedData.responseDate
        ? format(new Date(normalizedData.responseDate), DateFormats.ISO)
        : normalizedData.responseDate,
      offerDate: normalizedData.offerDate
        ? format(new Date(normalizedData.offerDate), DateFormats.ISO)
        : normalizedData.offerDate,
      estimatedReleaseDate: normalizedData.estimatedReleaseDate
        ? format(new Date(normalizedData.estimatedReleaseDate), DateFormats.ISO)
        : normalizedData.estimatedReleaseDate,
    });
  }

  static async deleteOffer(id: number): Promise<AxiosResponse> {
    return $api.delete(`/recruiting-tool/api/v1/offer/${id}`);
  }

  static async restoreOffer(id: number): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/offer/${id}`);
  }
}
